<template>
  <Card>
    <h1 class="lg:text-2xl font-bold mb-4 truncate">
      {{ translate("site.org.id.titles.header") }}
    </h1>
    <NamiLoading v-if="pending" />
    <p v-else-if="data?.meta?.total === 0" class="text-center">
      This Organization does not have any published Titles.
    </p>
    <TitlesView v-else-if="data" :titles="data.data" :meta="data.meta" />
  </Card>
</template>

<script setup lang="ts">
import { ALL_CONTENT, type OrganizationEntity, Title } from "~/src/api";

const nuxtApp = useNuxtApp();
const { t: translate } = nuxtApp.$i18n.global;
const props = defineProps<{
  org: OrganizationEntity;
}>();

const orgId = computed(() => props.org.id);

const { pending, data } = useAsyncData(`${orgId.value}-titles`, async () =>
  Title.search({
    organizationId: orgId.value,
    order: { updatedAt: "desc" },
    includes: ["cover_art"],
    contentRating: ALL_CONTENT,
  }),
);
</script>
